export function q1I (t) {
  return Math.pow(t, 4.0)
}

export function q1O (t) {
  return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0
}

export function q1IO (t) {
  return t < 0.5
    ? +8.0 * Math.pow(t, 4.0)
    : -8.0 * Math.pow(t - 1.0, 4.0) + 1.0
}

export function q2O (t) {
  return --t * t * t * t * t + 1
}

export function q2IO (t) {
  if ((t *= 2) < 1) return 0.5 * t * t * t * t * t
  return 0.5 * (t -= 2) * t * t * t * t + 2
}

export function q3IO (t) {
  t /= 0.5
  if (t < 1) return 0.5 * t * t
  t--
  return -0.5 * (t * (t - 2) - 1)
}

export function qO (t) {
  return -t * (t - 2.0)
}

export function q3O (t) {
  return t * (2 - t)
}

export function s0 (t) {
  return Math.sin((t * Math.PI) / 2)
}



//////////////////
// WEBPACK FOOTER
// ./scripts/util/nE.js
// module id = 1
// module chunks = 0